import React from "react";
import { useSelector } from "react-redux";
import { getElementById } from "../utils/styleUtils";

export const CustomTextBlock = ({ instanceId, isSubmission = false }) => {
  const formBuilder = useSelector((state) => state.customFormBuilder);
  const element = getElementById(instanceId, formBuilder);

  if (!element) {
    return <div>Text block element not found</div>;
  }

  const elementStyle = element.style || {};

  // Helper function to convert hex to rgba with opacity
  const hexToRgba = (hex, opacity) => {
    if (!hex) return hex;
    hex = hex.replace("#", "");
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const getTextBlockStyles = () => {
    const backgroundOpacity = elementStyle.backgroundOpacity || "1";
    const backgroundColor = elementStyle.backgroundColor || "#f8f9fa";

    return {
      fontSize: elementStyle.fontSize || "0.875rem",
      fontFamily: elementStyle.fontFamily || "inherit",
      color: elementStyle.textColor || "#212529",
      backgroundColor:
        backgroundOpacity !== "1"
          ? hexToRgba(backgroundColor, backgroundOpacity)
          : backgroundColor,
      padding: elementStyle.padding || "1rem",
      marginLeft: elementStyle.marginLeft || "0",
      marginRight: elementStyle.marginRight || "0",
      marginTop: elementStyle.marginTop || "0",
      marginBottom: elementStyle.marginBottom || "0.75rem",
      borderRadius: elementStyle.borderRadius || "0.375rem",
      borderStyle: elementStyle.borderStyle || "solid",
      borderColor: elementStyle.borderColor || "#ced4da",
      borderWidth: elementStyle.borderWidth || "1px",
      textAlign: elementStyle.textAlign || "left",
      fontWeight: elementStyle.fontWeight || "normal",
      fontStyle: elementStyle.fontStyle || "normal",
      lineHeight: elementStyle.lineHeight || "1.5",
      letterSpacing: elementStyle.letterSpacing || "normal",
      position: "relative",
    };
  };

  return (
    <div style={getTextBlockStyles()}>
      {/* Show label if it exists */}
      {/* {elementStyle.label?.label && (
        <h4
          style={{
            fontSize: elementStyle.labelFontSize || "1.25rem",
            fontWeight: elementStyle.labelFontWeight || "700",
            color: elementStyle.labelColor || "#2d3748",
            marginBottom: "1rem",
            lineHeight: "1.3",
            letterSpacing: "-0.025em",
            fontFamily: elementStyle.fontFamily || "inherit",
          }}
        >
          {elementStyle.label.label}
        </h4>
      )} */}

      {/* Render content with HTML support */}
      <div
        dangerouslySetInnerHTML={{
          __html:
            elementStyle.content ||
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
        }}
      />

      {/* Edit indicator for design mode */}
      {!isSubmission && (
        <div
          style={{
            position: "absolute",
            top: "4px",
            right: "4px",
            fontSize: "10px",
            color: "#999",
            opacity: "0.7",
            pointerEvents: "none",
          }}
        >
          ✏️
        </div>
      )}
    </div>
  );
};
